const STYLES = {
  draft: ["Draft", "bg-stone-500/10 text-stone-600 border-stone-500/30"],
  sent: ["Unpaid", "bg-sky-500/10 text-sky-700 border-sky-500/30"],
  overdue: ["Overdue", "bg-red-500/10 text-red-700 border-red-500/30"],
  paid: ["Paid", "bg-emerald-500/10 text-emerald-700 border-emerald-500/30"],
  void: ["Void", "bg-stone-500/10 text-stone-400 border-stone-400/30 line-through"],
};

export const InvoiceStatusBadge = ({ status, testId }) => {
  const [label, cls] = STYLES[status] || STYLES.draft;
  return <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${cls}`}>{label}</span>;
};
